/* =========================================================
   SANSARITA PRODUCT CARD — SHARED WAVE ANIMATION
   ========================================================= */

(function () {
  'use strict';

  const initializedSections = new WeakSet();

  function createWavePath(progress, amplitude) {

    const remaining =
      1 - progress;

    const base =
      1.30 * remaining;

    const waveAmplitude =
      amplitude *
      Math.pow(
        remaining,
        1.35
      );

    const peak =
      base -
      waveAmplitude;

    const valley =
      base +
      (waveAmplitude * 0.45);

    const rightPeak =
      base -
      (waveAmplitude * 0.55);

    return `
      M 0 ${base}

      C
        0.08 ${base}
        0.15 ${peak}
        0.32 ${peak}

      C
        0.42 ${peak}
        0.54 ${valley}
        0.68 ${valley}

      C
        0.78 ${valley}
        0.88 ${rightPeak}
        1 ${rightPeak}

      L 1 1
      L 0 1

      Z
    `;
  }


  function initSection(section) {

    if (
      !section ||
      initializedSections.has(section)
    ) {
      return;
    }

    initializedSections.add(section);


    const canHover =
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;


    if (!canHover) {
      return;
    }


    const cards =
      section.querySelectorAll(
        '[data-sansarita-card]'
      );


    cards.forEach(function (card) {

      const path =
        card.querySelector(
          '[data-wave-path]'
        );


      const hoverImage =
        card.querySelector(
          '.sansarita-product-card__hover-image'
        );


      if (
        !path ||
        !hoverImage
      ) {
        return;
      }


      /*
       * Safari / WebKit:
       *
       * Ocultamos completamente la segunda imagen
       * cuando la animación está cerrada para evitar
       * el pequeño remanente de 1px.
       */

      hoverImage.style.visibility =
        'hidden';


      let progress = 0;

      let target = 0;

      let animationFrame = null;

      let lastTime = null;


      const computedStyle =
        window.getComputedStyle(
          section
        );


      const duration =
        parseFloat(
          computedStyle.getPropertyValue(
            '--spc-animation-speed'
          )
        ) || 650;


      const amplitude =
        parseFloat(
          computedStyle.getPropertyValue(
            '--spc-wave-amplitude'
          )
        ) || 0.12;


      /*
       * Estado inicial
       */

      path.setAttribute(
        'd',
        createWavePath(
          0,
          amplitude
        )
      );


      /*
       * =====================================================
       * ANIMATION FRAME
       * =====================================================
       */

      function animate(timestamp) {

        if (!lastTime) {
          lastTime = timestamp;
        }


        const delta =
          timestamp -
          lastTime;


        lastTime =
          timestamp;


        const step =
          delta /
          duration;


        if (
          progress <
          target
        ) {

          progress =
            Math.min(
              target,
              progress + step
            );

        } else if (
          progress >
          target
        ) {

          progress =
            Math.max(
              target,
              progress - step
            );

        }


        path.setAttribute(
          'd',
          createWavePath(
            progress,
            amplitude
          )
        );


        if (
          Math.abs(
            progress -
            target
          ) > 0.001
        ) {

          animationFrame =
            requestAnimationFrame(
              animate
            );

        } else {

          progress =
            target;

          lastTime =
            null;

          animationFrame =
            null;


          /*
           * Cuando termina de cerrarse,
           * dejamos de pintar completamente
           * la segunda imagen.
           */

          if (
            target === 0
          ) {

            hoverImage.style.visibility =
              'hidden';

          }

        }

      }


      /*
       * =====================================================
       * MOUSE ENTER
       * =====================================================
       */

      card.addEventListener(
        'mouseenter',
        function () {

          hoverImage.style.visibility =
            'visible';


          target = 1;


          if (
            !animationFrame
          ) {

            lastTime =
              null;

            animationFrame =
              requestAnimationFrame(
                animate
              );

          }

        }
      );


      /*
       * =====================================================
       * MOUSE LEAVE
       * =====================================================
       */

      card.addEventListener(
        'mouseleave',
        function () {

          target = 0;


          if (
            !animationFrame
          ) {

            lastTime =
              null;

            animationFrame =
              requestAnimationFrame(
                animate
              );

          }

        }
      );

    });

  }


  /*
   * =========================================================
   * INITIALIZE ALL SANSARITA SECTIONS
   * =========================================================
   */

  function initAllSections() {

    document
      .querySelectorAll(
        '[data-sansarita-product-section]'
      )
      .forEach(
        initSection
      );

  }


  /*
   * =========================================================
   * INITIAL PAGE LOAD
   * =========================================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllSections
    );

  } else {

    initAllSections();

  }


  /*
   * =========================================================
   * SHOPIFY THEME EDITOR
   * =========================================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.closest(
          '[data-sansarita-product-section]'
        );


      if (section) {

        initSection(
          section
        );

      }

    }
  );

})();